<!--
~ Copyright (C) 2018 envisia GmbH
~ All Rights Reserved.
-->

@if (environment === 'Development' || environment === 'Testserver') {
  <div id="testserver">
    {{environment}}: {{version}}
  </div>
}
